<template>
  <a-modal
    :title="modalTit"
    :visible.sync="isLimitDialogShow"
    width="432px"
    :ok-text="mergeTitTxt"
    :cancel-text="cancelTxt"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="merge-creat-dilog-form">
      <p>{{ $t('message["1483"]') }}</p>
      <a-form
        :form="form"
      >
        <a-form-item
          label=""
        >
          <a-input
            v-decorator="decorators.username"
            :placeholder="accoutTitTxt"
          />
        </a-form-item>
        <a-form-item
          label=""
        >
          <a-input
            v-decorator="decorators.password"
            :placeholder="pwdPlaceholder"
            type="password"
          />
        </a-form-item>
        <!-- <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            登录
          </a-button>
        </a-form-item> -->
      </a-form>
    </div>
    <!-- <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="isLimitDialogShow=false">取消</el-button>
      <el-button
        type="primary"
        :disabled="submiting"
        @click="submitHandle('createForm')"
      >合并</el-button>
    </span> -->
    <bind-tips-dialog
      ref="tipsDialog"
      :value="value"
      :type-error="typeError"
    />
  </a-modal>
</template>
<script>
import { setAuth } from '@/lib/storage'
import BindTipsDialog from './BindTipsDialog'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    BindTipsDialog
  },
  props: {
    cId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      typeError: {},
      createForm: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState('merge', ['decorators']),
    value () {
      return this.form.getFieldValue('username')
    },
    accoutTitTxt () {
      return this.$t('message["202"]')
    },
    mergeTitTxt () {
      return this.$t('message["426"]')
    },
    modalTit () {
      return this.$t('message["430"]')
    },
    pwdPlaceholder () {
      return this.$t('message["762"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['ajaxSave']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.ajaxSave()
          chain.params(values)
            .onNetSuccess(d => {
              const res = d.data
              if (!res.error) {
                this.isLimitDialogShow = false
                // await this.$store.dispatch('login', res.payload.Authorization)
                setAuth(res.payload.Authorization)
                this.$store.commit('setAuth', res.payload.Authorization, { root: true })
                this.$router.push({ name: 'OrgIndex' })
                setTimeout(() => {
                  location.reload()
                }, 1000)
              } else if (res.error === 104 || (res.error === 105)) {
                this.typeError = res
                this.isLimitDialogShow = false
                this.$refs.tipsDialog.changeLimitDialog(true)
              } else {
                this.$message.warning(res.message)
              }
            })
            .setForm(this.form)
            .config({ warn: false })
            .fetch()
          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.merge-creat-dilog-form {
  margin-left: 20px;

  p {
    margin-bottom: 35px;
    font-weight: bold;
    color: #333;
  }
}
</style>
